import React from "react";
import { Location, Navigate, Outlet, useLocation } from "react-router-dom";
import { helpdeskPath, isHelpdeskPath, readPendingHelpdeskTicket } from "./helpdesk-deep-link";

/**
 * The signed-in routes' outlet, with one detour: a helpdesk link opened while signed out survives the
 * login page and the default landing page in this tab's storage, and the first signed-in page sends
 * the user on to it. Without a pending link it is a plain `<Outlet />`.
 *
 * A function component on purpose: it re-reads the location on every navigation. The class-based
 * `PrivateRoutes` never re-renders when only the address changes, so a redirect decided there kept
 * rendering `<Navigate>` after arriving at `/helpdesk` — a blank page that bounced every later
 * navigation back to it.
 */
const HelpdeskPendingTicketOutlet = (): React.ReactElement => {
  const location: Location = useLocation();
  const pendingTicket: number | null = readPendingHelpdeskTicket();
  if (pendingTicket !== null && !isHelpdeskPath(location.pathname)) {
    return <Navigate to={helpdeskPath(null, pendingTicket)} replace />;
  }
  return <Outlet />;
};

export default HelpdeskPendingTicketOutlet;
